/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";

// Authentication layout components
import IllustrationLayout from "../../components/IlllustrationLayout";

// Image
// import chat from '../../../../assets/gif/splash-screen-video.mp4';

import PalletLoader from "components/PalletLoader/PalletLoader";
import { userVerification, getUserDetails } from "config/Services";
import MuiAlert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import { useCookies } from "react-cookie";
import CircularProgress from "@mui/material/CircularProgress";
import { grey } from "@mui/material/colors";
import Snackbar from "@mui/material/Snackbar";
import Footer from "layouts/authentication/components/Footer";
import Card from "@mui/material/Card";
import * as React from "react";
import "./illustration.css";

function Illustration() {
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();
  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const [open, setOpen] = useState(false);
  const [vertical, setVertical] = useState("bottom");
  const [horizontal, setHorizontal] = useState("right");
  const [errorhandler, setErrorHandler] = useState("");
  const [mobile, setMobile] = useState("");
  const [disable, setDisable] = useState(true);
  const [esClr, setrEsClr] = useState("");
  const [cookies, setCookie] = useCookies(["user"]);
  const [loadingUr, setLoadingUr] = useState(false);
  const [successUr, setSuccessUr] = useState(false);
  const [loadingAuth, setLoadingAuth] = useState(false);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setCookie("isAuth", false, { path: "/" });
  }, []);
  //  }
  const handleMobile = (e) => {
    let number = e.target.value;
    setMobile(e.target.value);
    if (number.length === 10) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  };
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const createOtp = () => {
    const payload = {
      mobile: mobile,
    };
    if (!loadingUr) {
      setLoadingUr(true);
      setSuccessUr(false);
      userVerification(payload)
        .then((response) => {
          setLoadingUr(false);
          setSuccessUr(true);
          setCookie("access_token", response.data.data.at, { path: "/" });
          localStorage.setItem("access_token", response.data.data.at);
          sessionStorage.setItem("access_token", response.data.data.at);
          /* Auth context — used by Roles & Permissions screen */
          const _now = new Date().toISOString();
          if (!localStorage.getItem("sessionStartedAt"))
            localStorage.setItem("sessionStartedAt", _now);
          localStorage.setItem("lastTokenRefresh", _now);
          if (response?.data?.data?.rt)
            localStorage.setItem("refresh_token", response?.data?.data?.rt);
          sessionStorage.setItem("mob_no", mobile);
          navigate(`sign-in/otp/${mobile}`);
        })
        .catch((err) => {
          setSuccessUr(false);
          setLoadingUr(false);
          setrEsClr("error");
          if (err?.response?.data?.data?.code == 401) {
            setErrorHandler("You are not a registered user.Please go register in tha pallet app");
          } else {
            setErrorHandler("Something went wrong");
          }
          setOpen(true);
        });
    }
  };
  const resetPassword = () => {
    navigate("/forgot-password");
  };

  const keyHandler = (e) => {
    if (e.key == "Enter") {
      e.preventDefault();
      createOtp();
    }
  };

  let access_token = localStorage.getItem("access_token");
  useEffect(() => {
    setVisible(true);
    if (!loadingAuth) {
      setLoadingAuth(true);
      getUserDetails()
        .then((response) => {
          setTimeout(() => {
            setLoadingAuth(false);
            setVisible(false);
            navigate(`/dashboards/evernest/${access_token}`);
          }, 2000);
        })
        .catch((error) => {
          setTimeout(() => {
            setVisible(false);
            setLoadingAuth(false);
          }, 2000);
        });
    }
  }, []);

  return (
    <SoftBox>
      {loadingAuth ? (
        <PalletLoader />
      ) : (
        <IllustrationLayout
          title="Sign in"
          description="Enter your mobile number to sign in"
          illustration={{
            // image: chat,
            title: '"Attention is the new currency"',
            description:
              "The more effortless the writing looks, the more effort the writer actually put into the process.",
          }}
        >
          <SoftBox component="form" role="form">
            <SoftBox mb={2}>
              <SoftInput
                type="number"
                placeholder="Mobile number"
                size="large"
                value={mobile}
                onChange={handleMobile}
                onKeyPress={(e) => keyHandler(e)}
              />
            </SoftBox>

            <SoftBox mt={4} mb={1}>
              <SoftButton
                variant="gradient"
                color="info"
                size="large"
                disabled={loadingUr}
                onClick={() => createOtp()}
                fullWidth
              >
                {loadingUr ? (
                  <CircularProgress
                    size={24}
                    sx={{
                      color: "#fff",
                    }}
                    // className="add-customer-progress-otp"
                  />
                ) : (
                  <>Send Otp</>
                )}
              </SoftButton>
            </SoftBox>
            <SoftBox mt={3} textAlign="center">
              <SoftTypography variant="button" color="text" fontWeight="regular">
                Not registered yet?{" "}
              </SoftTypography>
            </SoftBox>
          </SoftBox>
        </IllustrationLayout>
      )}
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert
          onClose={handleCloseAlert}
          severity={successUr ? "success" : "error"}
          sx={{ width: "100%" }}
        >
          {errorhandler}
        </Alert>
      </Snackbar>
    </SoftBox>
  );
}

export default Illustration;
